(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  var root = form.closest('.product');

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}

  var idInput = form.querySelector('[data-variant-id]');
  var prices = root.querySelectorAll('[data-price]');
  var engravingWrap = form.querySelector('[data-engraving]');
  var engravingInput = form.querySelector('[data-engraving-input]');
  var backWrap = form.querySelector('[data-back]');
  var backInput = backWrap.querySelector('input');
  var counter = form.querySelector('[data-count]');
  var coinName = root.querySelector('[data-coin-name]');

  function selected(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }

  function update() {
    var size = selected('opt-size');
    var design = selected('opt-design');
    var v = variants.filter(function (x) { return x.size === size && x.design === design; })[0];
    if (v) {
      idInput.value = v.id;
      prices.forEach(function (p) { p.textContent = v.price; });
    }

    var textMode = design === 'Photo & text';

    engravingWrap.hidden = !textMode;
    engravingInput.disabled = !textMode;
    if (textMode) { engravingInput.setAttribute('required', ''); } else { engravingInput.removeAttribute('required'); }

    backWrap.hidden = textMode;
    backInput.disabled = textMode;
    if (!textMode) { backInput.setAttribute('required', ''); } else { backInput.removeAttribute('required'); }

    paintCoin();
  }

  function paintCoin() {
    if (!coinName) return;
    var textMode = selected('opt-design') === 'Photo & text';
    var val = (engravingInput.value || '').trim();
    coinName.textContent = textMode ? (val || 'Their name') : 'Their portrait';
  }

  form.addEventListener('change', function (e) {
    if (e.target.name === 'opt-size' || e.target.name === 'opt-design') update();
  });
  engravingInput.addEventListener('input', function () {
    counter.textContent = engravingInput.value.length;
    paintCoin();
  });

  var buybar = root.querySelector('[data-buybar]');
  var addBtn = form.querySelector('[data-add]');
  if (buybar && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      buybar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(addBtn);
  }

  // Form validation
  var photoInput = form.querySelector('[name="properties[Photo]"]');
  var photoWrap = photoInput ? photoInput.closest('.opt') : null;
  var errorMsg = form.querySelector('[data-validation-error]');
  if (!errorMsg) {
    errorMsg = document.createElement('p');
    errorMsg.className = 'validation-error';
    errorMsg.setAttribute('data-validation-error', '');
    errorMsg.hidden = true;
    addBtn.parentNode.insertBefore(errorMsg, addBtn.nextSibling);
  }

  // Photo upload success message
  var photoSuccess = document.createElement('p');
  photoSuccess.className = 'photo-success';
  photoSuccess.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Photo added successfully';
  photoSuccess.hidden = true;
  if (photoWrap) {
    var uploadsDiv = photoWrap.querySelector('.uploads');
    if (uploadsDiv) uploadsDiv.parentNode.insertBefore(photoSuccess, uploadsDiv.nextSibling);
  }

  if (photoInput) {
    photoInput.addEventListener('change', function () {
      if (photoInput.files && photoInput.files.length > 0) {
        photoSuccess.hidden = false;
        if (photoWrap) photoWrap.classList.remove('opt--error');
      } else {
        photoSuccess.hidden = true;
      }
    });
  }

  form.addEventListener('submit', function (e) {
    var missing = [];
    var photoEmpty = !photoInput || !photoInput.files || photoInput.files.length === 0;
    var engravingEmpty = !engravingInput.value || engravingInput.value.trim() === '';

    if (photoWrap) photoWrap.classList.remove('opt--error');
    if (engravingWrap) engravingWrap.classList.remove('opt--error');
    errorMsg.hidden = true;

    if (photoEmpty) {
      missing.push('Their photo');
      if (photoWrap) photoWrap.classList.add('opt--error');
    }
    if (engravingEmpty) {
      missing.push('Engraving');
      if (engravingWrap) engravingWrap.classList.add('opt--error');
    }

    if (missing.length > 0) {
      e.preventDefault();
      errorMsg.textContent = 'Please complete: ' + missing.join(' and ');
      errorMsg.hidden = false;
      var firstError = photoEmpty ? photoWrap : engravingWrap;
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  update();
})();

// Product image carousel
(function () {
  var mainImg = document.querySelector('.product__img');
  var thumbs = document.querySelectorAll('.product__thumb');
  if (!mainImg || thumbs.length === 0) return;

  thumbs.forEach(function (thumb, idx) {
    thumb.addEventListener('click', function () {
      mainImg.src = thumb.src.replace(/width=\d+/, 'width=1100');
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
    if (idx === 0) thumb.classList.add('active');
  });
})();
